import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_task_orderline_details_aggregateService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number, linenumber?: number }): 
  Promise<{ result: { TotalActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, LotId?: number, OrderLineNumber?: number, OrderId?: number, OperationCodeId?: number, StatusId?: number, Lot?: { LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, ActualTargetLicensePlate?: { LookupCode?: string }, Material?: { ControllerTypeId?: number } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId?: number, linenumber?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { TotalActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, LotId?: number, OrderLineNumber?: number, OrderId?: number, OperationCodeId?: number, StatusId?: number, Lot?: { LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, ActualTargetLicensePlate?: { LookupCode?: string }, Material?: { ControllerTypeId?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId?: number, linenumber?: number, $keys: { ActualTargetLicensePlateId?: number, LotId?: number, OrderLineNumber?: number, OrderId?: number, OperationCodeId?: number, Lot?: { LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, ActualTargetLicensePlate?: { LookupCode?: string }, StatusId?: number, Material?: { ControllerTypeId?: number } }[] }): 
  Promise<{ result: { TotalActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, LotId?: number, OrderLineNumber?: number, OrderId?: number, OperationCodeId?: number, StatusId?: number, Lot?: { LookupCode?: string }, VendorLot?: { ExpirationDate?: string }, ActualTargetLicensePlate?: { LookupCode?: string }, Material?: { ControllerTypeId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number, linenumber?: number    }) {
      return false;
    }
}
